import { ActionBarContent, ActionBarRoot, Button } from '@vesyl/ui'
import { HStack, Text, useDisclosure } from '@vesyl/ui/chakra'
import { useEffect } from 'react'

interface ActionBarFormProps {
  isOpen: boolean
  onDiscard: () => void
  loading?: boolean
  formId: string
}

export function FormActionBar({ isOpen, onDiscard, loading, formId }: ActionBarFormProps) {
  const { open, setOpen } = useDisclosure()

  const discard = () => {
    onDiscard()
    setOpen(false)
  }

  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen, setOpen])

  return (
    <ActionBarRoot open={open}>
      <ActionBarContent
        bg={{ _dark: 'bg.subtle', _light: 'bg.inverted' }}
        color={{ _dark: 'bg.inverted', _light: 'fg.inverted' }}
        mb="4"
        mx={{ base: '4', md: '0' }}
      >
        <HStack gap={{ base: '2', md: '3' }} flexWrap={{ base: 'wrap', md: 'nowrap' }}>
          <Text fontSize="sm" mr={{ base: '12', md: '44' }} ml="2" flex="1">
            Unsaved changes
          </Text>
          <Button
            variant="ghost"
            bg={{ _light: 'bg.inverted', _dark: 'transparent' }}
            color={{ _light: 'fg.inverted', _dark: 'fg.panel' }}
            _hover={{ bg: { _light: 'gray.700', _dark: 'gray.700' } }}
            onClick={discard}
            disabled={loading}
            size="md"
          >
            Discard
          </Button>
          <Button
            colorPalette="green"
            loading={loading}
            type={formId ? 'submit' : 'button'}
            form={formId}
            size="md"
          >
            Save
          </Button>
        </HStack>
      </ActionBarContent>
    </ActionBarRoot>
  )
}
